export default __webpack_public_path__ + "static/media/Standard10.4ae6589d.png";